<template>
  <div v-if="this.$config.guiSettings.pinnedMessage" class="pinnedMessage">
    <b-alert :variant="variant" show class="pinnedMessageAlert" v-b-popover.hover.top="tooltip">
      <div class="icon" v-html="info"></div>
      <span v-html="title"></span>
    </b-alert>
  </div>
</template>


<script>
  import { info } from '@/components/svg/common'
  export default {
    name: 'pinnedMessage',
    components: {

    },
    data(){
      return{
        title: (this.$config.guiSettings.pinnedMessage)? this.$config.guiSettings.pinnedMessage.title : '',
        tooltip: (this.$config.guiSettings.pinnedMessage)? this.$config.guiSettings.pinnedMessage.tooltip : '',
        variant: (this.$config.guiSettings.pinnedMessage)? this.$config.guiSettings.pinnedMessage.variant : '',
      }
    },
    created(){
      this.info = info
    }
  }
</script>

<style lang="scss" scoped>
  .pinnedMessage
  {
    display:flex;
    justify-content: center;
    align-items: center;
    margin-bottom:0px;
    text-align:center;
    width:100%;
    .alert
    {
      flex:1;
      width:100%;
      display:flex;
      justify-content: center;
      align-items: center;
      margin-bottom:0px;
      //font-weight: 500;
    }
    .icon
    {
      width:18px;
      margin-right:10px;
    }

  }

</style>